module.exports = __webpack_public_path__ + "static/media/LogoUniserved.392b7cc7.png";